import { BaseWebComponentDataProvider } from '../../../framework/BaseWebComponentDataProvider';
import { MaintenanceWindowSelectorWebComponentSchema } from '../types';

export class MaintenanceWindowSelectorBaseDataProvider extends BaseWebComponentDataProvider {
  async getDataForView(
    type: number,
    companyId: string,
    selectedMaintenanceWindowId: string
  ): Promise<MaintenanceWindowSelectorWebComponentSchema> {
    throw new Error('Not implemented');
  }
}
